import * as iconInsert from '../helpers/utilities/icon/insert';
import * as serializer from 'basic-editor-value-serializer';

export function createIconAction(editor, getPath, handleClick) {
  function insert() {
    iconInsert.insert(editor, getPath());
  }
  return {
    iconName: 'event-icon',
    label: 'Icon',
    description: 'Add a symbol or graphic',
    keywords: ['icon', 'symbol', 'graphic'],
    type: serializer.types.ICON,
    onClick() {
      handleClick(insert);
    },
    isVisible() {
      return iconInsert.canInsertAt(editor, getPath());
    }
  };
}
